import * as React from 'react';
import S from './SectionWrapper.styles';
export var Theme;
(function (Theme) {
    Theme["BlueGradient"] = "blue-gradient";
    Theme["Blue"] = "blue";
    Theme["GreenGradient"] = "green-gradient";
    Theme["Grey"] = "grey";
    Theme["OrangeGradient"] = "orange-gradient";
    Theme["PurpleGradient"] = "purple-gradient";
    Theme["RedGradient"] = "red-gradient";
    Theme["White"] = "white";
})(Theme || (Theme = {}));
const SectionWrapper = React.forwardRef((props, ref) => {
    const { id, children, layout = 'default', flush = 'none', background, ...otherProps } = props;
    return (React.createElement(S.Container, { ref: ref, id: id, "data-flush": flush, "data-theme": background, ...otherProps }, renderLayout()));
    function renderLayout() {
        if (layout === 'fullWidth') {
            return children;
        }
        return React.createElement(S.Inner, null, children);
    }
});
SectionWrapper.displayName = 'SectionWrapper';
export default SectionWrapper;
